export default "__VITE_ASSET__CuwpZ_ox__"